// extracted by mini-css-extract-plugin
export default {"about-layout":"aboutModal_about-layout__EOk7J","des":"aboutModal_des__8GMQZ","github-button":"aboutModal_github-button__tSSsl"};